(() => {
  const input = document.querySelector('#faq-search');
  const filters = [...document.querySelectorAll('.faq-filter')];
  const groups = [...document.querySelectorAll('[data-faq-group]')];
  const empty = document.querySelector('#faq-no-results');
  let category = 'all';
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  function update() {
    const query = normalize(input.value);
    let count = 0;
    groups.forEach(group => {
      let groupCount = 0;
      const matchCategory = category === 'all' || category === group.dataset.faqGroup;
      group.querySelectorAll('.faq-item').forEach(item => {
        const visible = matchCategory && (!query || normalize(item.textContent).includes(query));
        item.hidden = !visible;
        if (visible) { count++; groupCount++; }
        else item.open = false;
      });
      group.hidden = groupCount === 0;
    });
    empty.hidden = count > 0;
  }
  filters.forEach(filter => filter.addEventListener('click', () => {
    category = filter.dataset.faqFilter;
    filters.forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
    update();
  }));
  input.addEventListener('input', update);
})();
